import { has } from 'lodash'
import Vue from 'vue'

/**
 * Before each route we determine if the user has the necessary permissions to access the page
 * they are trying to get to.
 */
export default (to, from, next, user) => {
  if (has(to.meta, 'redirects')) {
    if (to.meta.redirects[Vue.prototype.$user.role]) {
      next({name: to.meta.redirects[Vue.prototype.$user.role], replace: true})
    }
  }

  next()
}
